import { render, staticRenderFns } from "./travel-policy-form.vue?vue&type=template&id=d21a8c7a&scoped=true&"
import script from "./travel-policy-form.vue?vue&type=script&lang=js&"
export * from "./travel-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./travel-policy-form.vue?vue&type=style&index=0&id=d21a8c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21a8c7a",
  null
  
)

export default component.exports